module.exports = __webpack_public_path__ + "static/media/5.26b69c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/5.png
// module id = 1171
// module chunks = 0